import { render, staticRenderFns } from "./Absences.vue?vue&type=template&id=ed94a31a&scoped=true"
import script from "./Absences.vue?vue&type=script&lang=js"
export * from "./Absences.vue?vue&type=script&lang=js"
import style0 from "./Absences.vue?vue&type=style&index=0&id=ed94a31a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed94a31a",
  null
  
)

export default component.exports